<template>
  <div class="animated fadeIn">

    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col lg="12">
            <b-alert show variant="light">Overdues Report</b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <hr/>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <ag-grid-vue class="ag-theme-balham"
              :gridOptions="gridOptions"
              id="AmountDueByPeriodGrid"
              :rowData="profileDuesList"
              :pagination="true"
              :paginationPageSize="50"
              :suppressNoRowsOverlay="true"
              :floatingFilter="true"
              @gridReady="gridReady">
            </ag-grid-vue>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Vue from 'vue'
  import {AgGridVue} from "ag-grid-vue";
  export default {
    name: 'AmountDueByPeriods',
    components: {
      AgGridVue
    },
    data: function() {
      return {
        profilesData: null,
        gridOptions: {
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agTextColumnFilter',

          },
          columnDefs: [
           {headerName: 'Profile Name', field: 'name', minWidth: 120,maxWidth: 300},
           {headerName: 'Address', field: 'houseno',minWidth: 100,maxWidth: 150},
           {headerName: 'Current (Till 4 Months)', field: 'periods.current', filter: 'agNumberColumnFilter',minWidth: 100,maxWidth: 250},
           {headerName: 'Older (Older than 4 Months)', field: 'periods.oldertotal',filter: 'agNumberColumnFilter',minWidth: 100,maxWidth: 250},
           {headerName: 'Total', field: 'total',filter: 'agNumberColumnFilter',maxWidth: 250}

         ]
       }
      }
    },
    computed: {
      profileDuesList: function(){
        return this.$store.state.electrical.amountOverdueData;
      }
    },
    methods:{
      gridReady(){
         this.gridOptions.api.sizeColumnsToFit();
      },
    },
    created() {
      if (this.$store.state.electrical.amountOverdueData.length == 0) {
        this.$store.dispatch('electrical/getAmountDueByPeriod')
      }
    },
    mounted() {
      console.log('New component mounted.')
    }
  }
</script>

<style lang="css">
</style>
